import domain from "../domain";
import OptionQuestion1 from "./OptionQuestion1";
import { useEffect, useState } from "react";
import classes from "./FeedbackFormComponent3.module.css";
import { useNavigate } from "react-router-dom";
import StarRating from "./StarRating";
import RemarksField from "./RemarksField";

function buildOptionQuestionResponse(qData) {
  const arr = [
    { title: "foodIssue", answer: "" },
    { title: "foodNameHavingIssue", answer: "" },
  ];
  (qData?.optionQuestions || []).forEach((item) => {
    arr.push({ title: item.title, answer: "" });
  });
  return arr;
}

function findFoodQuestionIndex(qData) {
  if (!qData?.optionQuestions) return undefined;
  return qData.optionQuestions.findIndex((item) =>
    item.title.toLowerCase().includes("food"),
  );
}

export default function FeedbackFormComponent3({ data, id }) {

  console.log("data inside component", data);
  const navigate = useNavigate();
  const qData = data?.qData;

  const [error, setError] = useState("");
  const [emptyOptionsIndex, setEmptyOptionsIndex] = useState([]);
  const [attributionQResponse, setAttributionsQResonse] = useState([
    "Yes",
    "none",
  ]);
  const [remarks, setRemarks] = useState({
    title: qData?.remarksTitle ? qData.remarksTitle : "Remarks",
    remarks: "",
  });
  const [rating, setRating] = useState(5);
  const [staffRating, setStaffRating] = useState(5);
  const [dinningAssistant, setDinnigAssistant] = useState({
    id: "",
    name: "Select",
    rating: 5,
  });
  const [optionQuestionResponse, setOptionQuestionResponse] = useState(() =>
    buildOptionQuestionResponse(qData),
  );

  const staffRatingEnabled = qData?.staffRatingEnabled;
  const staff = qData?.staff || [];
  const foodQuestionIndex = findFoodQuestionIndex(qData);

  useEffect(() => {
    setDinnigAssistant((prev) => ({
      ...prev,
      rating: staffRating,
    }));
  }, [staffRating]);

  if (data?.errorMessage) {
    return <p>{data.errorMessage}</p>;
  }

  if (!qData) {
    return <p>Invalid feedback data</p>;
  }

  localStorage.setItem(
    "externalReview",
    JSON.stringify(qData.externalReview),
  );

  function handleOptionsChange(title, answer) {
    setError("");
    setOptionQuestionResponse((prev) => {
      const updatedResponse = prev.map((item) => ({ ...item }));
      const ind = updatedResponse.findIndex((item) => item.title === title);
      if (ind === -1) return prev;

      setEmptyOptionsIndex((prevEmpty) =>
        prevEmpty.filter((item) => item !== ind - 2),
      );
      updatedResponse[ind].answer = answer;
      return updatedResponse;
    });
  }

  function handleAttribution(title, response) {
    const firstTitle = qData.attribution?.[0]?.title;
    if (title === firstTitle) {
      setAttributionsQResonse([response, "none"]);
    } else {
      setAttributionsQResonse((prev) => {
        const temp = [...prev];
        temp[1] = response;
        return temp;
      });
    }
  }

  function staffSelectHandler(e) {
    const v = e.target.value;
    if (v === "007") return;
    const index = v;
    setDinnigAssistant({
      id: staff[index].id,
      name: staff[index].name,
      rating: staffRating,
    });
  }

  function validateEmptyResponse(obj) {
    let validate = true;

    obj?.optionQuestions.forEach((item, index) => {
      if (index <= 1) return;

      if (item.answer === "") {
        setEmptyOptionsIndex((prev) => [...prev, index - 2]);
        setError(`Please choose the appropriate option above`);
        validate = false;
      }

      if (
        foodQuestionIndex !== undefined &&
        foodQuestionIndex !== -1 &&
        index - 2 === foodQuestionIndex
      ) {
        const foodOptions = qData.optionQuestions[foodQuestionIndex].options;
        if (item.answer === foodOptions[foodOptions.length - 1]) {
          if (
            obj.optionQuestions[0].answer === "" ||
            obj.optionQuestions[1].answer === ""
          ) {
            validate = false;
            setError("Food related field(s) empty.");
          }
        }
      }
    });

    if (staffRatingEnabled) {
      if (obj.staff.id === "") {
        validate = false;
        setError("Kindly Rate your Dinning Assistant");
      }
    }

    return validate;
  }

  function handleSubmit(e) {
    setError("");

    const object = {
      id,
      restaurantId: data.restaurantId,
      admin_id: data.admin_id,
      checkQuestions: [],
      
        bioDetails : data.data.bioDetails,
        optionQuestions : optionQuestionResponse,
        attribution : attributionQResponse,
       
      rating,
      remarks,
      simpleQuestions: [],
      staff: dinningAssistant,
    };
    console.log("object", object);
    let onSubmitRedirect = "/submitsuccess";
    if (
      Number(object.rating) === 5 &&
      qData.externalReview?.platform?.length > 3
    ) {
      onSubmitRedirect = "/externallink";
    }

    if (!validateEmptyResponse(object)) return;

    e.target.innerHTML = "Wait...";
    e.target.disabled = true;

    localStorage.setItem(
      "externalReview",
      JSON.stringify(qData.externalReview),
    );

    fetch(`${domain}/api/submitform`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(object),
    })
      .then((response) => {
        navigate(`${onSubmitRedirect}`);
        return response.json();
      })
      .catch(() => {
        e.target.innerHTML = "Submit";
        e.target.disabled = false;
        setError("Failed to submit. Please try again.");
      });
  }

  return (
    <>
      <div className={classes.container}>
        <h3>FeedBack Form</h3>
        <div className={classes.messageContainer}>
          <p>
            <strong>{qData.message}</strong>
          </p>
        </div>

        <form action="">
          <div>
            {qData.attribution?.[0] && (
              <OptionQuestion1
                key="attribution-0"
                data={qData.attribution[0]}
                index={"A"}
                isEmpty={false}
                onChangeHandle={handleAttribution}
              />
            )}

            {attributionQResponse[0] === "No" && qData.attribution?.[1] && (
              <OptionQuestion1
                key="attribution-1"
                data={qData.attribution[1]}
                index={"B"}
                isEmpty={false}
                onChangeHandle={handleAttribution}
              />
            )}
          </div>

          <div className={classes.optionQuestionsContainer}>
            <div className={classes.optionQuestions}>
              {qData.optionQuestions &&
                qData.optionQuestions.map((item, index) => {
                  const isEmpty = emptyOptionsIndex.includes(index);
                  return (
                    <OptionQuestion1
                      key={`option-${index}`}
                      data={item}
                      index={index}
                      isEmpty={isEmpty}
                      onChangeHandle={handleOptionsChange}
                    />
                  );
                })}
            </div>
          </div>

          <div className={classes.simpleQuestion}>
            <RemarksField
              title={remarks.title}
              changeHandler={(title, remarksText) =>
                setRemarks({ title, remarks: remarksText })
              }
            />
          </div>

          {staffRatingEnabled && (
            <div className={classes.ratingContainer}>
              <div>
                <label>Kindly rate your Dinning assistant </label>
                <select name="staff" id="staff" onChange={staffSelectHandler}>
                  <option value="007">Select</option>
                  {staff.map((item, index) => (
                    <option key={index} value={index}>
                      {item.name}
                    </option>
                  ))}
                </select>{" "}
                {dinningAssistant.name !== "Select" && (
                  <StarRating
                    rating={staffRating}
                    setRating={setStaffRating}
                  />
                )}
              </div>
            </div>
          )}

          <div className={classes.ratingContainer}>
            <div id="ratingStars">
              <label htmlFor="rating">Overall Rating : </label>
              <StarRating rating={rating} setRating={setRating} />
            </div>
          </div>

          <div className={classes.errorContainer}>
            <p>{error}</p>
          </div>
          <div className={classes.buttonContainer}>
            <button type="button" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </form>
        <br />
        <br />
      </div>
    </>
  );
}
